import { createRouter, createWebHashHistory } from 'vue-router'


const routes = [
  {
    path: '/',
    name: 'Landing',
    component: () => import('../components/LandingPage.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../components/ProjectsDashboard.vue')
  },
  {
    path: '/project/:project',
    name: ':project',
    component: () => import('../components/singleproject/SingleProject.vue')
  },
  {
    path: '/qa-docs',
    name: 'QA Documents',
    component: () => import('../components/QADocuments.vue')
  },
  {
    path: '/create-wiki',
    name: 'Create Wiki',
    component: () => import('../components/WikiDocView.vue')
  },
  {
    path: '/wiki/:wikiId',
    name: ':wikiId',
    component: () => import('../components/WikiDocView.vue')
  },
  {
    path: '/timeline',
    name: 'Timeline',
    component: () => import('../components/timeline/TimelineView.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes
})


export default router
